import {
	Role,
	RolesPermissionsState,
	RolePermissionLabel
} from './definitions';


export class RolesPermissionsFactory 
{
	public static build(): RolesPermissionsState 
	{
		return {
			foo: 'bar'
		};
	}
	public static buildRolelist(): Role 
	{
		return {
			id: '',
			name: '',
			description: '',
			locked: false,
			permissions: [],
			company: ''
		};
	}

	public static buildAddRolelist(): Role 
	{
		return {
			id: '',
			name: '',
			description: '',
			locked: false,
			permissions: [],
			company: '',
			action: 'Add'
		};
	}

	public static buildAEMLabels(): RolePermissionLabel 
	{
		return {
			pageHeading: '',
			roleListLabel: '',
			permissionLabel: '',
			detailHeading: '',
			addRole: '',
			removeRole: '',
			copyRole: '',
			roleName: '',
			description: '',
			saveChangesBtnText: '',
			unselectAllText: '',
			duplicateRoleNameErrorText: '',
			customRoleDefaultDescription: '',
			customRoleDefaultName: '',
			unSelectAllLabel: '',
			duplicateRoleErrorText: '',
			defaultRoleName: '',
			defaultRoleDescription: '',
			roleNameValidationError: '',
			toggleOffAltText: '',
			toggleOnAltText: '',
			toggleOffDisabledAltText: '',
			toggleOnDisabledAltText: '',
			deleteConfirmation: [{
				headingMain: '',
				headingSub: '',
				manageLabel: '',
				cancel: '',
				removeRole: '',
				users: ''
			}],
			ellipsesIcon: {
				iconPath: '',
				altText: ''
			},
			addRoleIcon: {
				iconPath: '',
				altText: ''
			},
			removeRoleIcon: {
				iconPath: '',
				altText: ''
			},
			userIcon: {
				iconPath: '',
				altText: ''
			},
			closeIcon: {
				iconPath: '',
				altText: ''
			},
			permissionLabels: [{
				sectionHeader: '',
				categoryGroup: '',
				permissionArr: [{
					permissionKey: '',
					permissionDescription: '',
					permissionShortDescription: '',
					permissionId: ''
				}]
			}]
		};
	}
}
